<template>
  <v-container grid-list-md>
    <v-layout wrap>
      <v-flex xs12>
        <content-field
          label="Name"
          @blur="$v.formData.name.$touch()"
          :error="$v.formData.name"
          v-model="formData.name">
        </content-field>
      </v-flex>

      <v-flex xs12>
        <content-field
          label="Code"
          @blur="$v.formData.code.$touch()"
          :error="$v.formData.code"
          v-model="formData.code">
        </content-field>
      </v-flex>

      <v-flex xs12>
        <content-field
          label="Use Count"
          @blur="$v.formData.useCount.$touch()"
          :error="$v.formData.useCount"
          v-model="formData.useCount">
        </content-field>
      </v-flex>

      <v-layout class="date-picker-container">
        <v-flex xs11 sm12>
          <v-dialog
            persistent
            v-model="isActivationDateModalOpen"
            ref="dialogActivationDate"
            lazy
            full-width
            width="290px"
          >
            <v-text-field
              slot="activator"
              label="Select activation date"
              v-model="activationDate"
              value="activationDate"
              prepend-icon="event"
              readonly
            />
            <v-date-picker
              v-model="activationDate"
              :min="getCurrentDate()"
              value="activationDate"
              no-title scrollable
            >
              <v-spacer></v-spacer>
              <v-btn flat color="primary" @click="toggleModal('isActivationDateModalOpen')">Cancel</v-btn>
              <v-btn flat color="primary" @click="$refs.dialogActivationDate.save(formData.activationDate)">OK</v-btn>
            </v-date-picker>
          </v-dialog>
        </v-flex>
      </v-layout>

      <v-layout xs12 class="date-picker-container">
        <v-flex xs11 sm12>
          <v-dialog
            persistent
            v-model="isExpirationDateModalOpen"
            ref="dialogExpirationDate"
            lazy
            full-width
            width="290px"
          >
            <v-text-field
              slot="activator"
              label="Select expiration date"
              v-model="expirationDate"
              value="expirationDate"
              prepend-icon="event"
              readonly
            />
            <v-date-picker
              v-model="expirationDate"
              value="expirationDate"
              :min="getMinExpirationDate"
              :readonly="!activationDate"
              no-title scrollable
            >
              <v-spacer></v-spacer>
              <v-btn flat color="primary" @click="toggleModal('isExpirationDateModalOpen')">Cancel</v-btn>
              <v-btn flat color="primary" @click="$refs.dialogExpirationDate.save(expirationDate)">OK</v-btn>
            </v-date-picker>
          </v-dialog>
        </v-flex>
      </v-layout>
      <v-flex xs6>
        <v-switch
          :label="`Status: ${formData.status.toString()}`"
          v-model="formData.status"
          true-value="Live"
          false-value="Stopped"
        />
      </v-flex>
    </v-layout>
    <v-layout column>
      <p>Pick discount type</p>
      <v-radio-group
        xs12
        v-model="discountStatus"
        :mandatory="false"
      >
        <v-radio
          label="Discount in Percent"
          value="percent"
        />
        <v-radio
          label="Discount in Currency"
          value="currency"
        />
      </v-radio-group>
      <content-field
        label="Discount"
        :error="$v.discount"
        :customErrorMessages="errorMessages"
        v-model="discount">
      </content-field>
    </v-layout>
  </v-container>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import { required, numeric, between } from 'vuelidate/lib/validators'
  import { clone } from 'ramda'

  export default {
    name: "promo-codes-form",
    components: {},
    props: {
      editableItem: {
        type: Object,
        default: null
      }
    },
    data () {
      return {
        isModalGalleryOpen: false,
        formData: {
          name: '',
          useCount: '',
          activationDate: '',
          expirationDate: '',
          discountInPercent: null,
          discountInCurrency: null,
          status: 'Live'
        },
        activationDate: this.getCurrentDate(),
        expirationDate: this.getCurrentDate(),
        isActivationDateModalOpen: false,
        isExpirationDateModalOpen: false,
        discount: '',
        discountStatus: 'percent'
      }
    },
    validations () {
      const validationRules = {
        formData: {
          name: { required },
          code: { required },
          useCount: { required, numeric }
        }
      }

      if (this.discountStatus === 'percent') {
        validationRules.discount = { required, between: between(1, 100)}
      } else {
        validationRules.discount = { required, numeric}
      }
      return validationRules
    },
    computed: {
      getMinExpirationDate () {
        if (this.activationDate) {
          return this.activationDate
        } else {
          return this.getCurrentDate()
        }
      },
      errorMessages () {
        return [
        {
          type: 'between',
          message: 'This field should be between 1 and 100'
        },
        {
          type: 'required',
          message: `This field is required`
        }
        ]
      }
    },
    methods: {
      ...mapActions([
        'addPromoCode',
        'editPromoCode'
      ]),
      toggleModal (varModal) {
        this[varModal] = !this[varModal]
      },
      async savePromoCodeItem () {
        this.createPayload()
        this.$v.$touch()
        if (this.$v.$invalid) {
          return false
        }
        if (this.editableItem) {
          try {
            await this.editPromoCode(this.formData)
          } catch (err) {
            throw err
          }
        } else {
          try {
            await this.addPromoCode(this.formData)
          } catch (err) {
            throw err
          }
        }
        return true
      },
      createPayload () {
        this.formData.activationDate = `${this.activationDate}T00:00:00.000Z`
        this.formData.expirationDate = `${this.expirationDate}T00:00:00.000Z`
        if (this.discountStatus === 'percent') {
          this.formData.discountInCurrency = ''
          this.formData.discountInPercent = this.getFractionalNumber(this.discount)
        } else {
          this.formData.discountInPercent = ''
          this.formData.discountInCurrency = this.discount
        }
      },
      convertDiscountData () {
        if (this.editableItem.discountInPercent) {
          this.discountStatus = 'percent'
          this.discount = this.editableItem.discountInPercent * 100 // 1-100% better than 0.1-1
        } else {
          this.discountStatus = 'currency'
          this.discount = this.editableItem.discountInCurrency
        }
      },
      convertDateForForm () {
        const activationDate = this.$moment(this.editableItem.activationDate)
        const expirationDate = this.$moment(this.editableItem.expirationDate)
        this.activationDate = this.$moment(activationDate).format('YYYY-MM-DD')
        this.expirationDate = this.$moment(expirationDate).format('YYYY-MM-DD')
      },
      getCurrentDate () {
        return this.$moment(new Date ()).format('YYYY-MM-DD')
      },
      getFractionalNumber (value) {
        return value / 100
      }
    },
    mounted () {
      if (this.editableItem) {
        this.formData = clone(this.editableItem)
        this.convertDiscountData()
        this.convertDateForForm()
      }
    }
  }
</script>

<style scoped>
  .error-message {
    font-size: 13px;
    color: #ff171e;
    position: absolute;
    bottom: -10px;
    left: 8px;
  }

  .date-picker-container {
    position: relative;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/PromoCodes/promoCodesForm.vue